import React from 'react';
import { Outlet } from 'react-router';
import { Link } from 'react-router-dom';

const CouponsMain = () => {

return (
    <>
    <div style={{ display: 'flex'}}>
        <div style={{ flex: "50%"}}>
            <p className='lead text-dark' style={{ padding: "1rem"}}>Coupons</p>
        </div>
        <div style={{ flex: "50%", paddingTop: "1rem"}}>
            <Link to='all'><button type="button" className="btn btn-outline-primary">All Coupons</button></Link>
            <Link to='add'><button type="button" className="btn btn-outline-success">Add Coupon</button></Link>
        </div>
    </div>
    <hr style={{padding: "0px"}}/>
    <Outlet />
    </>
)};

export default CouponsMain;